/***************************************************************************************************
 * Load `$localize` onto the global scope - used if i18n tags appear in Angular templates.
 */
import '@angular/localize/init'

/** Evergreen browsers require these. **/
import 'core-js/es/reflect'
/**
 * Required to support Web Animations `@angular/animation`.
 * Needed for: All but Chrome, Firefox and Opera. http://caniuse.com/#feat=web-animation
 **/
import 'web-animations-js' // Run `npm install --save web-animations-js`.
/***************************************************************************************************
 * Zone JS is required by Angular itself.
 */
import 'zone.js' // Included with Angular CLI.

/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
 *      file.
 *
 * The current setup is for so-called "evergreen" browsers; the last versions of browsers that
 * automatically update themselves. This includes Safari >= 10, Chrome >= 55 (including Opera),
 * Edge >= 13 on the desktop, and iOS 10 and Chrome on mobile.
 *
 * Learn more in https://angular.io/docs/ts/latest/guide/browser-support.html
 */
/***************************************************************************************************
 * BROWSER POLYFILLS
 */

// load all IE specific polyfills trough external hosted API
// this will improve loading time
try {
    // @ts-ignore
    const isIE = /*@cc_on!@*/ false || !!document.documentMode
    if (isIE) {
        const script = document.createElement('script')
        script.src = 'https://polyfill.io/v3/polyfill.min.js?features=es6%2CElement.prototype.classList%2Cfetch'
        document.head.appendChild(script)
    }
} catch {}

/***************************************************************************************************
 * APPLICATION IMPORTS
 */

// nothing to see here, move along
